export default "__VITE_ASSET__3790b1f3__"